import React from "react";
import { generateShortId } from "utils/short-id";

export const useShortId = () => {
  const id = React.useRef(generateShortId());
  return id.current;
};
